import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

import keycloak from '../keycloak';
import { Api } from './repo-service';
import { Api as WAPI, Api as WFApi } from './workflow-server';


// const MLFLOW_BASE_URL = 'http://localhost/mlflow'; NOT USED
// const MLFLOW_BASE_URL = 'http://mlflow.centurion.localhost/ajax-api/2.0/mlflow'
// const GITEA_BASE_URL = 'http://version-control.centurion.localhost/api/v1';
// const BASE_URL = 'http://centurion.localhost';
// const CORE_BASE_URL = 'http://localhost/core/api/v1';
// const WORKFLOW_BASE_URL = 'http://wapi.centurion.localhost';
// const EXECUTIONS_BASE_URL = 'http://wapi.centurion.localhost';
// const KEYCLOCK_BASE_URL = 'http://auth.centurion.localhost/admin/realms/centurion';

const MLFLOW_BASE_URL = `${process.env.REACT_APP_MLFLOW_BASE_URL}/ajax-api/2.0/mlflow`
const GITEA_BASE_URL = `${process.env.REACT_APP_GITEA_BASE_URL}/api/v1`;
// const BASE_URL = 'http://centurion.localhost';
const CORE_BASE_URL = `${process.env.REACT_APP_CORE_BASE_URL}/core/api/v1`;
const WORKFLOW_BASE_URL = `${process.env.REACT_APP_WORKFLOW_BASE_URL}`;
const EXECUTIONS_BASE_URL = `${process.env.REACT_APP_EXECUTIONS_BASE_URL}`;
const KEYCLOCK_BASE_URL = `${process.env.REACT_APP_KEYCLOCK_BASE_URL}/admin/realms/centurion`;

// const EXECUTIONS_BASE_URL = 'http://localhost:8081';

export const axiosMlFlowInstance = axios.create({
  baseURL: MLFLOW_BASE_URL,
  timeout: 15000,
});

export const axiosKeycloakInstance = axios.create({
  baseURL: KEYCLOCK_BASE_URL,
  timeout: 15000,
})

export const axiosGiteaInstance = axios.create({
  baseURL: GITEA_BASE_URL,
  timeout: 15000,
});

export const axiosCoreInstance = axios.create({
  baseURL: CORE_BASE_URL,
  timeout: 15000,
})

// export const axiosDefaultInstance = axios.create({
//   baseURL: BASE_URL,
//   timeout: 15000,
// });

export const axiosRepoIntance = new Api({
  baseURL: GITEA_BASE_URL,
  timeout: 15000
});

export const axiosWorkflowIntance = new WAPI({
  baseURL: WORKFLOW_BASE_URL,
  timeout: 15000
});

export const executionsApiClient = new WFApi({
  baseURL: EXECUTIONS_BASE_URL,
});

// GITEA INSTANCE
axiosGiteaInstance.interceptors.request.use(
  async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
    try {
      await keycloak.updateToken(30); // Update the token if it's going to expire in 30 seconds
      const { tokenParsed } = keycloak;
      const gitea_api_token = tokenParsed && tokenParsed['gitea_api_token'];

      if (gitea_api_token) {
        config.headers["Authorization"] = `token ${gitea_api_token}`;
      } else {
        console.warn("gitea_api_token not found in tokenParsed");
      }
    } catch (error) {
      console.error("Failed to update Keycloak token", error);
      // Handle error, e.g., redirect to login or show a notification
    }

    return config;
  },
  (error: AxiosError): Promise<AxiosError> => {
    return Promise.reject(error);
  }
);

axiosKeycloakInstance.interceptors.request.use(
  async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
    await keycloak.updateToken();
    const { token } = keycloak;
    config.headers.set("Authorization", `Bearer ${token}`);
    return config
  },
  (error: AxiosError): Promise<AxiosError> => {
    return Promise.reject(error);
  }
);

axiosMlFlowInstance.interceptors.request.use(
  async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
    await keycloak.updateToken();
    const { token } = keycloak;
    config.headers.set("Authorization", `Bearer ${token}`);
    return config
  },
  (error: AxiosError): Promise<AxiosError> => {
    return Promise.reject(error);
  }
);

// DEFAULT INSTANCE
// axiosDefaultInstance.interceptors.request.use(
//   async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
//     await keycloak.updateToken();
//     const { token } = keycloak;
//     config.headers.set("Authorization", `Bearer ${token}`);
//     return config
//   },
//   (error: AxiosError): Promise<AxiosError> => {
//     return Promise.reject(error);
//   }
// );

// axiosDefaultInstance.interceptors.response.use(
//   (response: AxiosResponse): AxiosResponse => {
//     return response;
//   },
//   (error: AxiosError): Promise<AxiosError> => {
//     const { onAuthError } = keycloak
//       ;
//     if (error?.response && error?.response?.status === 401) {
//       onAuthError && onAuthError({ error: error.name, error_description: error.message });
//     }
//     return Promise.reject(error);
//   }
// )
